export default {
  name: 'Login',
  methods: {
    async login () {
      if (this.userId === 'admin' && this.userPwd === 'fdcadm') {
        this.$router.push('/fdc/monitor/dashboard')
      // } else if (this.userId === 'cowin' && this.userPwd === 'fdcdemo') {
      //   this.$router.push('/fdc/monitor/dashboard')
      } else {
        this.$dialog.alert('로그인 정보를 확인해주세요.')
      }
    }
  },
  data () {
    return {
      username: '',
      password: '',
      userId: '',
      userPwd: '',
      checkUserId: 'admin',
      checkPwd: 'brique',
      warningVisible: false,
      warningTxt: '',
      currentTab: 'Notice',
      TAB: [
        {
          id: 'NOTICE',
          name: 'Notice'
        },
        {
          id: 'FAQ',
          name: 'FAQ'
        }
      ]
    }
  }
}
